import { EventSchema } from '../../interfaces/EventInterfaces'
import { EVENT_NAME as EN } from '../../constants/EventName'
import { BannerClickedEventSchema } from './BannerClickedEventSchema'

export const BannerViewedEventSchema: EventSchema = {
  ...BannerClickedEventSchema,
  eventName: EN.BANNER_VIEWED,
}
